import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const CheckGlyph = /*#__PURE__*/createElement("g", {
  id: "check"
}, /*#__PURE__*/createElement("path", {
  d: "M42,18c13.2,0,24,10.8,24,24S55.2,66,42,66S18,55.2,18,42S28.8,18,42,18 M42,15c-14.9,0-27,12.1-27,27 s12.1,27,27,27s27-12.1,27-27S56.9,15,42,15L42,15z"
}), /*#__PURE__*/createElement("path", {
  d: "M56,31.8c-0.6-0.6-1.8-0.7-2.4,0L36.7,48.6l-6.3-6.3c-0.7-0.7-1.8-0.7-2.4,0c-0.3,0.3-0.5,0.8-0.5,1.2 c0,0.5,0.2,0.9,0.5,1.2l7.5,7.5c0.3,0.3,0.8,0.5,1.2,0.5c0.5,0,0.9-0.2,1.2-0.5L56,34.2c0.3-0.3,0.5-0.8,0.5-1.2S56.3,32.1,56,31.8 z"
}));
const Check = createSvg({
  name: 'check',
  path: CheckGlyph
});

export default Check;
export { CheckGlyph };
